<template>
  <div>
    <label class="form__label primary--text" :for="idElement">
      {{ labelText }}
    </label>
    <BaseSelect
      ref="selectInput"
      v-on="$listeners"
      v-bind="defaultConfigs"
      :id="idElement"
    />
  </div>
</template>
<script>
export default {
  computed: {
    defaultConfigs() {
      return Object.assign(
        {
          outlined: true,
          class: "mt-2"
        },
        {
          ...this.$attrs,
          ...this.$props
        }
      );
    }
  },
  props: {
    idElement: {
      type: String
    },
    labelText: {
      type: String
    }
  }
};
</script>
